<template>
  <div
    class="lanoga-select"
    @click="onSelectClick"
    v-click-outside="hideOptionList"
    :class="{ 'read-only': readonly }"
  >
    <div class="input-wrapper d-flex">
      <input
        type="text"
        class="requiredInput"
        :value="selectedItem"
        :name="name"
        v-if="required"
        required
      />
      <div
        class="select-text flex-fill d-flex align-items-center"
        v-html="getItemHTML"
      ></div>
    </div>
    <div class="select-option-list" v-show="isOpenList">
      <input
        class="select-search"
        type="text"
        v-model="queryText"
        ref="search"
        :placeholder="
          options.locale && options.locale['searchPlaceholder']
            ? $cte(options.locale['searchPlaceholder'])
            : ''
        "
      />
      <div v-if="loading" class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="text-center py-3" v-if="filteredOptionList.length < 1 && !loading">
        {{
          options.locale && options.locale["noResults"]
            ? $cte(options.locale["noResults"])
            : ""
        }}
      </div>
      <ul v-if="filteredOptionList.length > 0 && !loading">
        <li
          v-for="(item, index) in filteredOptionList"
          v-bind:key="index"
          @click="onSelectItem(item, $event)"
          v-html="renderOption(item)"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "LanogaSelect",
  props: {
    value: { type: [Object, String, Number] },
    options: { type: Object },
    externalOptionList: { type: Array },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    name: { type: String },
    additionalApiCallbackParams: { type: Object },
  },
  data() {
    return {
      optionList: [],
      filteredOptionList: [],
      selectedItem: null,
      queryText: null,
      isOpenList: false,
      loading: false,
    };
  },
  created: function () {
    this.updateSelectInput();
  },
  computed: {
    getItemHTML: function () {
      if (this.options.formatText && this.selectedItem) {
        //ha van formázó fv a kiváklasztott elemre azt használja
        return this.options.formatText(this.selectedItem);
      } else {
        return this.$cte(this.selectedItem);
      }
    },
  },
  methods: {
    updateSelectInput() {
      let self = this;
      if (self.options.apiCallback) {
        //ha van api hívás megadva akkor azt használja
        if (!self.options.searchOnServer) {
          self.loading = true;
          self.options
            .apiCallback()
            .then((response) => {
              if (self.options.mapperCallback) {
                self.optionList = self.options.mapperCallback(response.data);
              } else {
                self.optionList = response.data;
              }
              self.searchSelectedItem();
              self.optionsFiltering();
              self.loading = false;
            })
            .catch((err) => {
              console.error(err);
              self.loading = false;
            });
        } else {
          self.searchSelectedItem();
        }
      } else {
        this.optionList = this.externalOptionList; // ha nincs api ahonnan a lehetőségeket kérje, akkor külső listát használ
        this.optionsFiltering();
        self.searchSelectedItem();
      }
    },

    renderOption(data) {
      if (this.options.formatOption && data) {
        //ha van formázó fv a lehetőségekre akkor azt használja
        return this.options.formatOption(data);
      } else {
        return this.$cte(data);
      }
    },

    onSelectItem(data, event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.options.returnValue) {
        //ha nem obijektummal hanem egy adattagjával szeretnénk visszatérni
        this.$emit("input", data[this.options.returnValue]);
      } else {
        this.$emit("input", data);
      }

      this.selectedItem = data;
      this.hideOptionList();
      this.$emit("select", data);
    },

    searchSelectedItem() {
      let self = this;
      if (self.value !== null && self.value !== undefined) {
        if (self.options.returnValue) {
          self.selectedItem = self.optionList.find((value) => {
            return value[self.options.returnValue] == self.value;
          });

          if (!self.selectedItem || self.selectedItem === "") {
            self.selectedItem = {};
            if (typeof self.value === "object") {
              self.selectedItem = self.value;
            } else {
              self.selectedItem[self.options.filteredAttr] = self.value;
            }
          }
        } else {
          self.selectedItem = self.value;

          if (!self.selectedItem[self.options.filteredAttr]) {
            self.selectedItem = {};
            if (typeof self.value === "object") {
              self.selectedItem = self.value;
            } else {
              self.selectedItem[self.options.filteredAttr] = self.value;
            }
          }
        }
      }
    },

    optionsFiltering() {
      let self = this;

      if (!self.options.minimumInputLength) {
        if (this.options.searchOnServer) {
          self.searchOnServer();
        } else {
          self.searchOnLocale();
        }
      } else {
        if (
          self.queryText &&
          self.queryText.length >= self.options.minimumInputLength
        ) {
          if (this.options.searchOnServer) {
            self.searchOnServer();
          } else {
            self.searchOnLocale();
          }
        } else {
          self.filteredOptionList = [];
        }
      }
    },

    searchOnServer() {
      let self = this;
      self.loading = true;
      this.options
        .apiCallback({
          params: {
            ...self.additionalApiCallbackParams,
            term: self.queryText,
            type: "query",
          },
        })
        .then((response) => {
          if (self.options.mapperCallback) {
            self.filteredOptionList = self.options.mapperCallback(
              response.data
            );
          } else {
            self.filteredOptionList = response.data;
          }
          self.loading = false;
        })
        .catch((err) => {
          console.error(err);
          self.loading = false;
        });
    },

    searchOnLocale() {
      let self = this;
      self.filteredOptionList = self.optionList.filter((value) => {
        if (self.options.filteredAttr && self.queryText) {
          return value[self.options.filteredAttr]
            .toLowerCase()
            .includes(self.queryText.toLowerCase());
        }
        return true;
      });
    },

    onSelectClick() {
      if (!this.readonly) {
        let self = this;
        self.isOpenList = true;
        setTimeout(function () {
          self.$refs.search.focus();
        }, 10);
      }
    },

    hideOptionList() {
      this.isOpenList = false;
      this.resetSelect();
    },

    resetSelect() {
      this.queryText = null;
    },
  },

  watch: {
    queryText: function () {
      this.optionsFiltering();
    },

    value: function (val) {
      if (!val || val === "") {
        this.selectedItem = undefined;
      }

      this.updateSelectInput();
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style scoped>
.lanoga-select {
  //background-color: #edf5ec;
  position: relative;
  //height: 38px !important;
  //padding: 0 0.5rem;
  //line-height: 1.5;
  //border-radius: 0.2rem;

  border-radius: 32px !important;
  background: rgba(174, 191, 199, 0.50);
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10);
  //font-size: 12px !important;
  padding: 15px !important;
}

.lanoga-select * {
  cursor: pointer;
}

.lanoga-select.read-only {
  background-color: rgba(174, 191, 199, 0.50);
}

.input-wrapper {
  height: 100%;
  max-width: 100%;
}

.requiredInput {
  position: absolute;
  z-index: -1000;
  width: 1px;
  height: 1px;
  border: none;
}

.select-text {
  color: gray;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.select-clear-wrapper button {
  background-color: transparent;
  color: #888888;
  border: none;
}

.select-option-list {
  margin-left: -15px;
  margin-top: -30px;
  background-color: white;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10);
  position: absolute;
  width: 100%;
  //border: 1px solid #ced4da;
  border-radius: 32px !important;
  z-index: 2;
  max-height: 400px;
  overflow: auto;
}

.select-search {
  border: 1px solid #ced4da;
  border-radius: 0.2rem;
  width: 100%;
  padding: 10px !important;
  outline-offset: -2px;
  -webkit-appearance: none;
}

.select-option-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.select-option-list ul li {
  padding: 6px;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
}

.select-option-list ul li:hover {
  background-color: #5bb65d;
  color: white;
}

/*Loader*/

.lds-ellipsis {
  display: block;
  position: relative;
  width: 64px;
  height: 35px;
  margin: auto;
}

.lds-ellipsis div {
  position: absolute;
  top: 12px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #5bb65d;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
